export const routes = {
  depositHome: '/',
  manageCards: '/manage-cards',
} as const
